export class TipoMedicionMobile {

public
public  idCompania: string;
public  fecha: Date;
public  idMedicion: string;
public  valor: string;
public  id: string;
public  idUsuario: string;
public  idVehiculo: string;

public  nombreUsuario: string;
public descripcion:string;

}